import React, { memo } from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import TopNavBar from '../components/NavBar';
import { GettingStartedModal, SaveWebsiteModal, WelcomeApp } from '../components/SaraPresentation';
import SideBar from '../components/SideBar';
import Spinner from '../components/Spinner';
import { PRODUCT_KEY } from '../constants';
import { fetchProducts, getSubscribe } from '../features/forfait/forfaitSlice';
import { selectUserInfo } from '../features/users/userInfoSlice';
import { fetchWebsites, selectTotal } from '../features/websites/websitesSlice';

export function EngagementIcon(props) {
  return (
    <svg width="1.25em" height="1em" viewBox="0 0 640 512" {...props}>
      <path
        fill="currentColor"
        d="M543.9 251.4c0-1.1.1-2.2.1-3.4c0-48.6-39.4-88-88-88H304v88c0 22.1-17.9 40-40 40s-40-17.9-40-40V128h.4c4-36 34.5-64 71.6-64h112c2.8 0 5.6.2 8.3.5l40.1-40.1c21.9-21.9 57.3-21.9 79.2 0l78.1 78.1c21.9 21.9 21.9 57.3 0 79.2L544 251.4zM192 128v120c0 39.8 32.2 72 72 72s72-32.2 72-72v-56h120c30.9 0 56 25.1 56 56c0 27.2-19.4 49.9-45.2 55c8.2 8.6 13.2 20.2 13.2 33c0 26.5-21.5 48-48 48h-2.7c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48H224c-.9 0-1.8 0-2.7-.1l-37.7 37.7c-21.9 21.9-57.3 21.9-79.2 0l-78.1-78c-21.9-21.9-21.9-57.3 0-79.2L96 258.7V224c0-53 43-96 96-96z"
      ></path>
    </svg>
  );
}

export function MarketIcon(props) {
  return (
    <svg width="1.17em" height="1em" viewBox="0 0 28 24" {...props}>
      <path
        fill="currentColor"
        d="M.482 24a.393.393 0 0 1-.389-.393v-1.783c0-.217.176-.393.393-.393h1.347V8.671a.79.79 0 0 1 .039-.244l-.002.006a3.265 3.265 0 0 1-1.8-1.287l-.007-.011A.39.39 0 0 1 0 6.921V.394C0 .177.176.001.393 0h27.014c.217 0 .393.176.393.393V6.92a.396.396 0 0 1-.064.215l.001-.002a3.49 3.49 0 0 1-2.687 1.468h-.008V21.43h1.091c.217 0 .393.176.393.393v1.783a.393.393 0 0 1-.393.393h-.001zm22.99-2.965V8.673c0-.07.009-.138.026-.202l-.001.006a3.498 3.498 0 0 1-1.53-.836l.002.002a3.82 3.82 0 0 1-2.68.976h.006a3.811 3.811 0 0 1-2.69-.996l.003.003a3.81 3.81 0 0 1-2.574.995l-.119-.002h.006a3.816 3.816 0 0 1-2.69-.996l.003.003a3.812 3.812 0 0 1-2.575.995l-.128-.002h.006a3.814 3.814 0 0 1-2.69-.996l.003.003a3.742 3.742 0 0 1-2.441.993h-.005v12.417H4.56v-5.253c0-.217.176-.393.393-.393h4.651c.217 0 .393.176.393.393v5.253zM19.295 7.833a3.028 3.028 0 0 0 2.2-.835l-.001.001a.364.364 0 0 1-.009-.083V.787h-4.41V6.92l.001.027l-.001.028v-.001a3.025 3.025 0 0 0 2.117.861l.11-.002h-.005zm-10.758 0l.106.002c.824 0 1.571-.328 2.118-.861l-.001.001l-.001-.027l.001-.028v.001V.788H6.312v6.133l.001.027l-.001.028v-.001a3.025 3.025 0 0 0 2.117.861l.112-.002h-.005zm2.873 10.495a.393.393 0 0 1-.393-.393v-6.821c0-.217.176-.393.393-.393h11.009c.217 0 .393.176.393.393v6.822a.393.393 0 0 1-.393.393h-.001z"
      ></path>
    </svg>
  );
}

export function SyntheseIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <path
        fill="currentColor"
        d="M28 22h2v8h-2zm-4-4h2v12h-2zm-4 8h2v4h-2zM9 16a7 7 0 1 0 7 7a7.008 7.008 0 0 0-7-7zm4.899 6H10v-3.899A5.014 5.014 0 0 1 13.899 22zM9 28a5 5 0 0 1-1-9.899V22a2 2 0 0 0 2 2h3.899A5.008 5.008 0 0 1 9 28zm13.535-16l4-6H30V4h-4.535l-4 6H18V2h-2v12a2 2 0 0 0 2 2h12v-2H18v-2z"
      ></path>
      <circle cx="11" cy="7" r="1" fill="currentColor"></circle>
      <circle cx="9" cy="11" r="1" fill="currentColor"></circle>
      <circle cx="7" cy="5" r="1" fill="currentColor"></circle>
      <circle cx="5" cy="9" r="1" fill="currentColor"></circle>
      <circle cx="3" cy="13" r="1" fill="currentColor"></circle>
    </svg>
  );
}

const NavigationLayout = ({ children }) => {
  const dispatch = useDispatch();
  const subscription = useSelector(state => state.subscriptions);
  const userInfoContext = useSelector(selectUserInfo)
  const totalWebsites = useSelector(selectTotal)
  const [valueNextStep, setValueNextStep] = useState(false)

  useEffect(() => {
    if (!sessionStorage.getItem(PRODUCT_KEY))
      dispatch(getSubscribe({ company_id: userInfoContext?.user?.company_id }))
    dispatch(fetchProducts())
    dispatch(fetchWebsites({ company_id: userInfoContext?.user?.company_id }))
  }, [userInfoContext?.user?.company_id])

  const showWelcome = !subscription.product_id && !localStorage.getItem(`${userInfoContext?.user?.company_id}_welcome`)
  const openSaveModal = !!subscription.product_id && !localStorage.getItem(userInfoContext?.user?.company_id) && totalWebsites <= 0

  return (
    <div className="w-full mx-auto bg-gray-50 h-full scroll-smooth">
      <WelcomeApp open={showWelcome} />
      {subscription.showModal === 'DONE' && <SaveWebsiteModal open={openSaveModal} goNext={setValueNextStep} />}
      {valueNextStep && <GettingStartedModal open={valueNextStep} actionOnClose={setValueNextStep} />}
      <TopNavBar />
      <div className="flex">
        <div className="flex-shrink">
          <SideBar />
        </div>
        <div className="flex-1 mx-4">
          {
            subscription.loading ?
              <div className="w-full mx-auto flex justify-center mt-40">
                <Spinner />
              </div> : children
          }
        </div>
      </div>
    </div>
  );
};

export default memo(NavigationLayout);
